import React, { useState, useEffect } from "react";
import { Row, Col, Input, Divider, Button, Tooltip, Card } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { snapAllCreditNotesRedeem } from "../../../../store/credit_redeem/credit_redeem.action";
import { unSnapCreditNotesRedeem } from "../../../../store/credit_redeem/credit_redeem.action";
import { labelDateSelector } from "../../../../store/var/var.selector";
import { detailBranchSelector } from "../../../../store/branch/branch.selector";
import { CloseOutlined, PlusCircleFilled } from "@ant-design/icons";
import { formatNumber } from "../../../../store/utils/format_number/format_number";
import lodash from "lodash";
import DialogCreditRedeemAdd from "./../../dialog/dialog_credit_redeem_add";
import { allSelector } from "../../../../store/credit_notes/credit_notes.selector";

const CreditNoteRedeemed = ({ edit }) => {
  // -------------------------- STATE --------------------------

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  // -------------------------- FUNCTION --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const label = useSelector(labelDateSelector);
  const branch = useSelector(detailBranchSelector);
  const creditNotes = useSelector(allSelector);
  // -------------------------- EFFECT --------------------------

  useEffect(() => {
    if (label && branch) {
      dispatch(
        snapAllCreditNotesRedeem({ date: label, branch: branch?.id }, (res) => {
          if (res) {
            let data = res?.notes;
            setData(data);
          } else {
            setData(null);
          }
        })
      );
    }

    return () => dispatch(unSnapCreditNotesRedeem());
  }, [dispatch, label, branch]);
  // -------------------------- RENDER --------------------------

  const renderList = () => {
    if (!data || data?.length === 0) {
      return <Row style={{ width: "100%" }}>No Gift Taken</Row>;
    }
    return (
      <Row style={{ width: "100%" }}>
        {data?.map((item, index) => {
          const note = item?.note;
          const value = item?.value;
          const labelValue = formatNumber(value);

          return (
            <Row key={index} style={{ width: "100%", margin: "6px 0px" }}>
              <Col span={14}>{note}</Col>
              <Col align="right" span={10}>
                ${labelValue}
              </Col>
            </Row>
          );
        })}
      </Row>
    );
  };

  const renderAddIcon = () => {
    return (
      <Tooltip title="Add Credit Redeem Note">
        <Button
          type="text"
          shape="circle"
          onClick={() => setOpen(true)}
          disabled={!edit}
          icon={
            <span className="anticon">
              <PlusCircleFilled
                style={{ fontSize: 24, color: edit ? "green" : "gray" }}
              />
            </span>
          }
        />
      </Tooltip>
    );
  };
  const renderTotal = () => {
    const finalValue = lodash?.sumBy(data, (d) => d?.value);
    const labelFinal = formatNumber(finalValue);
    return labelFinal;
  };
  // -------------------------- MAIN --------------------------
  const title = (
    <Row style={{ width: "100%" }}>
      <Col span={14}>Gift Taken:</Col>
      <Col align="right" span={10}>
        ${renderTotal()}
      </Col>
    </Row>
  );
  return (
    <Row span={24} style={{ width: "100%" }}>
      <Col span={24}>
        <Card className="item-card" title={title}>
          <Col span={24}>{renderList()}</Col>
          <Col span={24}>{renderAddIcon()}</Col>
          <DialogCreditRedeemAdd open={open} setOpen={setOpen} />
        </Card>
      </Col>
    </Row>
  );
};

export default CreditNoteRedeemed;
